export default {
  namespaced: true,
  state: {

  },
  mutations: {

  },
  actions: {
    // Our actions will have writes to firebase DB
    // The DB collections will be synced with state
  },
  getters: {

  },
};
